import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Avatar,
  Divider,
  ListItem,
  Box,
  ListItemText,
  Grid,
  IconButton,
} from "@material-ui/core";
import * as React from "react";
import CheckIcon from "@material-ui/icons/Check";
import CrossIcon from "@material-ui/icons/Close";
import YESMoodGoodIcon from "@material-ui/icons/Mood";
import NOMoodBadIcon from "@material-ui/icons/MoodBad";
import CommentIcon from "@material-ui/icons/Comment";
import ThumbsUpIcon from "@material-ui/icons/ThumbUp";
import ThumbsDownIcon from "@material-ui/icons/ThumbDown";
import DigitsIcon from "@material-ui/icons/Dialpad";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import pointRightFinger from "../assets/images/finger.png";
import ResponseTypeComponent from "./ResponseTypeComponent";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  questionItem: any;
  itemKey: any;
  editAction?: any;
  deleteAction?: any;
}
class QuestionItemComponent extends React.Component<Props> {
  getResponseTypeIcon = (typeKey: any) => {
    switch (typeKey) {
      case "CHECK":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <CheckIcon style={{ margin: 5 }} fontSize={"small"} />
            <CrossIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );
      case "TEXT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <YESMoodGoodIcon style={{ margin: 5 }} fontSize={"small"} />
            <NOMoodBadIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );

      case "COMMENT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <CommentIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );
      case "INTERACTIVE_1":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <ThumbsUpIcon
              style={{ margin: 5, color: "green" }}
              fontSize={"small"}
            />
            <ThumbsDownIcon
              style={{ margin: 5, color: "red" }}
              fontSize={"small"}
            />
          </div>
        );
      case "INTERACTIVE_2":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <ThumbsUpIcon
              style={{ margin: 5, color: "green" }}
              fontSize={"small"}
            />
            <img
              alt={"interactive_right_thumb"}
              width={25}
              height={25}
              style={{
                margin: 5,
                justifyContent: "center",
                alignItems: "center",
              }}
              src={pointRightFinger}
            />
          </div>
        );
      case "NUMERIC":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <DigitsIcon style={{ margin: 5 }} fontSize={"small"} />
          </div>
        );
    }
  };
  render() {
    const { questionItem, editAction, deleteAction, itemKey } = this.props;
    return (
      <React.Fragment key={itemKey.toString()}>
        <ListItem>
          <Box
            boxShadow={editAction || deleteAction ? 2 : 0}
            style={{
              margin: 0,
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            {/* {questionItem.legend && (
              <Avatar
                style={{
                  margin: 10,
                  backgroundColor: `${questionItem.legend.inputColor}`,
                  color: `${questionItem.legend.textColor}`,
                }}
              >
                {questionItem.legend.legendCode}
              </Avatar>
            )} */}
            {!questionItem.legend && (
              <Avatar
                style={{
                  margin: 10,
                  color: "black",
                  backgroundColor: "#ffffff",
                }}
              >
                {"N/A"}
              </Avatar>
            )}
            <ListItemText
              primary={"Question"}
              secondary={questionItem.question}
            />
            <Grid
              container
              item
              style={{ padding: 10 }}
              xs={6}
              justify="center"
              direction="row"
            >
              <Grid item xs={9}>
                <ListItemText
                  primary={"Response Type"}
                  secondary={questionItem.responseType.label}
                />
              </Grid>
              <Grid container item xs={3} justify="center" alignItems="center">
                {
                  <ResponseTypeComponent
                    feedBack={false}
                    typeKey={questionItem.responseType.title}
                    responseType={questionItem.responseType}
                  />
                }
              </Grid>
            </Grid>
          </Box>
          {editAction || deleteAction ? (
            <Grid item xs={1} container justify={"flex-end"} spacing={2}>
              {editAction && (
                <IconButton
                  aria-label="delete"
                  size="small"
                  style={{ marginLeft: 5 }}
                  onClick={() => editAction(questionItem, itemKey)}
                >
                  <EditIcon fontSize="inherit" />
                </IconButton>
              )}
              {deleteAction && (
                <IconButton
                  aria-label="delete"
                  size="small"
                  onClick={() => deleteAction(questionItem, itemKey)}
                >
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              )}
            </Grid>
          ) : (
            <div></div>
          )}
        </ListItem>
        <Divider variant="inset" />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(QuestionItemComponent);
